import {NavigationEntityState, NavigationItemExpandedState} from '~ui/store/slices/navigation-tree';

export function addChild(
    parent: NavigationEntityState,
    child: NavigationEntityState,
    index: number,
) {
    parent.children.splice(index, 0, child.slug);

    child.parent = parent.slug;

    // if parent is in `needs-expand` or `expanded` state
    // we should not change anything.
    if (parent.expandedState !== NavigationItemExpandedState.Closed) return;

    // if `hasChildren` is `true` and the only child that we have
    // is the one that we just added above, we must put a `parent`
    // into `needs-expand` state, so it loads other items on expand
    if (parent.hasChildren && parent.children.length === 1) {
        parent.expandedState = NavigationItemExpandedState.NeedsExpand;
    } else {
        parent.expandedState = NavigationItemExpandedState.Expanded;
    }

    parent.hasChildren = true;
}

export function removeChildAtIndex(parent: NavigationEntityState, index: number) {
    parent.children.splice(index, 1);
    if (parent.children.length > 0) return;

    if (parent.expandedState === NavigationItemExpandedState.NeedsExpand) {
        parent.hasChildren = true;
        parent.expandedState = NavigationItemExpandedState.Closed;
    } else {
        parent.hasChildren = false;
        // be default the state of the item is closed
        parent.expandedState = NavigationItemExpandedState.Closed;
    }
}
